import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import flowRight from 'lodash/flowRight'
import { translate } from 'loankeeper-common/helpers'
import { actions as LKModalActions } from '../../../shared/LKModal'
import { destroy } from '../../../shared/LKGrid'
import withLookups, { LookupType } from '../../../shared/containers/withLookups'
import { actions as DetailsContainerActions } from '../../../DetailsContainer'
import { accountOperAccessPermAdd, accountOperAccessPermDelete, isAccountOperLoading } from 'src/store/account'
const translateLKMessage = (key) => translate(`LKMESSAGE-${key}`)

const mapStateToProps = (state) => ({
  loading: isAccountOperLoading(state),
})

const mapDispatchToProps = (dispatch, { ID: AccountID, hash }) => ({
  handleModalClose: () => {
    dispatch(destroy('AccountPermissionAdd'))
  },
  openConfirmation: (ID) => {
    dispatch(
      LKModalActions.openConfirmation('AccountDeleteAccessPermission', {
        ID,
      } as any),
    )
  },
  addPermission: async (permissionID) => {
    try {
      const result = await dispatch(
        accountOperAccessPermAdd({
          AccountID,
          HashSum_AccountID_: hash,
          ID: permissionID,
        }),
      )
      const payload = result.payload

      if (accountOperAccessPermAdd.fulfilled.match(result)) {
        dispatch(LKModalActions.close('AccountPermissionAdd'))
        dispatch(destroy('AccountPermissionAdd'))
        dispatch(
          DetailsContainerActions.fetchPage({
            ID: AccountID,
            hash,
            type: 'Account',
            page: 'permslist',
          }),
        )
      } else {
        throw payload
      }
    } catch (error) {
      dispatch(LKModalActions.openInfo(translateLKMessage(error.message)))
    }
  },
})

export default flowRight(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withLookups({ type: LookupType.Users }),
)
